import * as React from 'react';
import {connect} from 'react-redux';
import {Switch, Route, Redirect} from 'react-router-dom';

import * as Leads from 'nutshell-core/leads';

import {SalesAutomationApp} from './app/sales-automation-app';
import {SalesAutomationSetupHome} from './home/sales-automation-setup-home';

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        fetchLeadListSchema() {
            dispatch(Leads.fetchSchemaAction());
        },
    };
}

const SalesAutomationRedirects = () => (
    <Switch>
        <Redirect exact={true} from='/setup/sales-automation' to='/sales/pipelines' />
        <Redirect
            exact={true}
            from='/setup/sales-automation/:stagesetId'
            to='/sales/pipelines/:stagesetId'
        />
    </Switch>
);

type DispatchProps = {
    fetchLeadListSchema: () => void;
};

type Props = DispatchProps;

class SalesAutomationRootComponent extends React.PureComponent<Props> {
    UNSAFE_componentWillMount() {
        this.props.fetchLeadListSchema();
    }

    render() {
        return (
            <>
                <SalesAutomationRedirects />
                <Switch>
                    <Route
                        path='/setup/sales-automation/:stagesetId'
                        component={SalesAutomationApp}
                    />
                    <Route
                        exact={true}
                        path='/setup/sales-automation'
                        component={SalesAutomationSetupHome}
                    />
                    <Route path='/sales/pipelines/:stagesetId' component={SalesAutomationApp} />
                    <Route
                        exact={true}
                        path='/sales/pipelines'
                        component={SalesAutomationSetupHome}
                    />
                </Switch>
            </>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, Record<any, any>, _, _, _, _>(null, mapDispatchToProps);
export const SalesAutomationRoot = connector(SalesAutomationRootComponent);
